// Đọc sheet "Lương _Đào tạo" của file BẢNG LƯƠNG THÁNG ... (Excel kế toán) thành danh sách dòng.
// aoa = mảng các dòng (XLSX.utils.sheet_to_json(ws, { header: 1, raw: true })).
// Không lấy Số tài khoản / Ngân hàng.
export const CONG_DAO_TAO_COLS = [
  { key: "mnv", idx: 1, label: "MNV" },
  { key: "hoten", idx: 2, label: "Họ và tên" },
  { key: "chucVu", idx: 3, label: "Chức vụ" },
  { key: "truong", idx: 4, label: "Trường" },
  { key: "congThoaThuan", idx: 5, label: "Công thoả thuận", num: true },
  { key: "congThucTe", idx: 6, label: "Công thực tế", num: true },
  { key: "tietVuot", idx: 7, label: "Tiết vượt / bổ trợ", num: true },
  { key: "luongCoBan", idx: 8, label: "Lương cơ bản", money: true },
  { key: "luongNgayCong", idx: 9, label: "Lương theo ngày công", money: true },
  { key: "pcDungLop", idx: 11, label: "PC Đứng lớp", money: true, nhom: "Phụ cấp" },
  { key: "pcChuyenMon", idx: 12, label: "PC Chuyên môn", money: true, nhom: "Phụ cấp" },
  { key: "pcDienThoai", idx: 13, label: "PC Điện thoại", money: true, nhom: "Phụ cấp" },
  { key: "pcChucVu", idx: 14, label: "PC Chức vụ/GVCN", money: true, nhom: "Phụ cấp" },
  { key: "pcXangXe", idx: 15, label: "PC Xăng xe", money: true, nhom: "Phụ cấp" },
  { key: "pcAn", idx: 16, label: "PC Ăn", money: true, nhom: "Phụ cấp" },
  { key: "pcKhac", idx: 17, label: "PC Khác", money: true, nhom: "Phụ cấp" },
  { key: "pcTong", idx: 18, label: "Tổng phụ cấp", money: true, nhom: "Phụ cấp" },
  { key: "quaTang", idx: -1, label: "🎁 Quà 20-10(HS)", money: true }, // không có trong file kế toán — nhập riêng
  { key: "quaTangNT", idx: -1, label: "🎁 Quà 20-10(NT)", money: true }, // quà Nhà trường — nhập riêng
  { key: "tongThuNhap", idx: 19, label: "Tổng thu nhập", money: true },
  { key: "luongDongBhxh", idx: 20, label: "Lương đóng BHXH", money: true, nhom: "Khoản phải trừ" },
  { key: "bhxh", idx: 21, label: "BHXH (10,5%)", money: true, nhom: "Khoản phải trừ" },
  { key: "congDoan", idx: 22, label: "Kinh phí công đoàn", money: true, nhom: "Khoản phải trừ" },
  { key: "thueTNCN", idx: 23, label: "Thuế TNCN", money: true, nhom: "Khoản phải trừ" },
  { key: "truKhac", idx: 24, label: "Khác / Phạt", money: true, nhom: "Khoản phải trừ" },
  { key: "tongPhaiTru", idx: 25, label: "Tổng phải trừ", money: true, nhom: "Khoản phải trừ" },
  { key: "phiNganHang", idx: 26, label: "Phí ngân hàng", money: true },
  { key: "tamUng", idx: 27, label: "Tạm ứng", money: true },
  { key: "thucLinh", idx: 28, label: "Thực lĩnh", money: true },
  { key: "soTienCK", idx: -1, label: "Số tiền CK", money: true }, // nhập riêng (không có trong file kế toán)
  { key: "hoanVe", idx: -1, label: "Hoàn về", money: true }, // = Số tiền CK − Thực lĩnh (tự tính)
  { key: "ghiChu", idx: 34, label: "Ghi chú" },
  { key: "ghiChuPhuCap", idx: 35, label: "Ghi chú phụ cấp" },
  { key: "ghiChuKhauTru", idx: 36, label: "Ghi chú khấu trừ" },
];

const s = (v) => (v === null || v === undefined ? "" : String(v).replace(/\s+/g, " ").trim());
const n = (v) => {
  if (v === null || v === undefined || v === "" || v === "-") return null;
  const x = typeof v === "number" ? v : Number(String(v).replace(/[.,\s]/g, ""));
  return Number.isFinite(x) ? Math.round(x * 100) / 100 : null;
};

export function parseCongDaoTao(aoa) {
  const rows = aoa || [];
  const hi = rows.findIndex((r) => r && /h[oọ]\s*v[aà]\s*t[eê]n/i.test(s(r[2])) && /stt/i.test(s(r[0])));
  if (hi < 0) throw new Error("Không thấy dòng tiêu đề (STT / Họ và Tên) trong sheet.");
  const tieuDe = s((rows.slice(0, hi).find((r) => r && r.some((c) => /B[ẢA]NG L[ƯU][ƠO]NG/i.test(s(c)))) || []).find((c) => /B[ẢA]NG L[ƯU][ƠO]NG/i.test(s(c))));
  const out = [];
  let nhom = "";
  for (let i = hi + 1; i < rows.length; i++) {
    const r = rows[i] || [];
    const ten = s(r[2]);
    if (/^t[oổ]ng/i.test(s(r[0]))) break;
    if (!ten || /^\d+$/.test(ten)) continue;
    if (/^[IVX]+\.\s/.test(ten) && n(r[0]) === null) { nhom = ten; continue; }
    if (n(r[0]) === null && !s(r[1])) continue;
    const o = { stt: n(r[0]), nhom };
    CONG_DAO_TAO_COLS.forEach((c) => {
      const v = c.money || c.num ? n(r[c.idx]) : s(r[c.idx]);
      if (v !== null && v !== "") o[c.key] = c.money ? Math.round(v) : v;
    });
    out.push(o);
  }
  return { tieuDe, rows: out };
}

// ---- Sheet "Danh sách ứng lương tháng ..." và "QTKD_T..." (danh sách chuyển khoản) ----
// Dò cột theo tiêu đề; thứ tự cột giống file Excel (có Ngân hàng / Số tài khoản).
const RE_NH = /ng[aâ]n\s*h[aà]ng/i;
const RE_TK = /t[aà]i\s*kho[aả]n/i;
export const TAM_UNG_COLS = [
  { key: "hoten", label: "Họ và tên", re: /t[eê]n/i },
  { key: "boPhan", label: "Bộ phận", re: /gvcn|b[oộ]\s*ph[aậ]n/i },
  { key: "soTien", label: "Số tiền ứng", re: /ti[eề]n|l[uư][oơ]ng/i, money: true },
  { key: "nganHang", label: "Ngân hàng", re: RE_NH, bank: true },
  { key: "soTaiKhoan", label: "Số tài khoản", re: RE_TK, bank: true, acct: true },
  { key: "noiDung", label: "Nội dung", re: /n[oộ]i\s*dung/i },
  { key: "ghiChu", label: "Ghi chú", re: /ghi\s*ch[uú]/i },
];
export const QTKD_COLS = [
  { key: "hoten", label: "Họ và tên", re: /t[eê]n/i },
  { key: "soTien", label: "Lương", re: /l[uư][oơ]ng|ti[eề]n/i, money: true },
  { key: "soTaiKhoan", label: "Số tài khoản", re: RE_TK, bank: true, acct: true },
  { key: "nganHang", label: "Ngân hàng", re: RE_NH, bank: true },
  { key: "noiDung", label: "Nội dung", re: /n[oộ]i\s*dung/i },
  { key: "ghiChu", label: "Ghi chú", re: /ghi\s*ch[uú]/i },
];

export function parseBangChuyenKhoan(aoa, cols) {
  const rows = aoa || [];
  const hi = rows.findIndex((r) => r && /stt/i.test(s(r[0])) && r.some((c) => /t[eê]n/i.test(s(c))));
  if (hi < 0) throw new Error("Không thấy dòng tiêu đề (STT / Họ tên) trong sheet.");
  const head = rows[hi].map((c) => s(c).normalize("NFC"));
  const used = new Set();
  const idx = {};
  cols.forEach((c) => {
    const i = head.findIndex((h, j) => !used.has(j) && j > 0 && c.re.test(h) && (c.bank || !(RE_NH.test(h) || RE_TK.test(h))));
    if (i >= 0) { idx[c.key] = i; used.add(i); }
  });
  if (idx.hoten === undefined) throw new Error("Không thấy cột Họ tên.");
  const tieuDe = s((rows.slice(0, hi).map((r) => (r || []).map(s).find((x) => /DANH S[AÁ]CH/i.test(x))).find(Boolean)) || "");
  const out = [];
  for (let i = hi + 1; i < rows.length; i++) {
    const r = rows[i] || [];
    if (/^t[oổ]ng/i.test(s(r[0])) || /^t[oổ]ng/i.test(s(r[idx.hoten]))) break;
    const ten = s(r[idx.hoten]);
    if (!ten) continue;
    const o = { stt: n(r[0]) };
    cols.forEach((c) => {
      if (idx[c.key] === undefined) return;
      const raw = r[idx[c.key]];
      const v = c.money ? n(raw) : c.acct && typeof raw === "number" ? raw.toFixed(0) : s(raw);
      if (v !== null && v !== "") o[c.key] = c.money ? Math.round(v) : v;
    });
    out.push(o);
  }
  return { tieuDe, rows: out };
}

// ---- "BẢNG CHẤM CÔNG PHÒNG ĐÀO TẠO" (mỗi sheet 1 tuần) -> tiền ăn trưa ----
// Đi làm TRỌN 1 ngày (ô = 1) được ANTRUA_DON_GIA; nửa ngày (0.5) không tính.
export const ANTRUA_DON_GIA = 10000;
export function parseChamCongDaoTao(sheets) {
  const people = {};
  const order = [];
  let thang = "";
  (sheets || []).forEach((aoa) => {
    const rows = aoa || [];
    if (!thang) {
      const t = rows.slice(0, 4).map((r) => (r || []).map(s).join(" ")).join(" ").match(/th[aá]ng\s*(\d{1,2})\s*\/\s*(\d{4})/i);
      if (t) thang = `${t[2]}-${String(t[1]).padStart(2, "0")}`;
    }
    const hi = rows.findIndex((r) => r && /stt/i.test(s(r[0])) && r.some((c) => /t[eê]n/i.test(s(c))));
    if (hi < 0) return;
    const head = rows[hi].map(s);
    const congCol = head.findIndex((h) => /c[oô]ng\s*ng[aà]y/i.test(h));
    const dayRow = rows[hi + 1] || [];
    const dayCols = [];
    for (let j = 3; j < (congCol > 0 ? congCol : dayRow.length); j++) if (n(dayRow[j]) !== null) dayCols.push(j);
    let boPhan = "";
    for (let i = hi + 2; i < rows.length; i++) {
      const r = rows[i] || [];
      const rawTen = s(r[2]);
      if (/^t[oổ]ng/i.test(rawTen) || /hi[eệ]u\s*tr/i.test(s(r[1]))) break;
      if (s(r[1])) boPhan = s(r[1]);
      if (!rawTen || n(r[0]) === null) continue;
      const m = rawTen.match(/^(.*?)\s*\((.*)\)\s*$/);
      const hoten = (m ? m[1] : rawTen).trim();
      const key = hoten.normalize("NFC").toLowerCase();
      if (!people[key]) { people[key] = { hoten, boPhan, ghiChu: m ? m[2] : "", congNgay: 0, ngayTron: 0, ngayNua: 0, chiTiet: [] }; order.push(key); }
      const p = people[key];
      dayCols.forEach((j) => {
        const v = n(r[j]);
        const ngay = n(dayRow[j]);
        if (v === null) { if (s(r[j])) p.chiTiet.push(`${ngay}:${s(r[j])}`); return; }
        p.congNgay += v;
        if (v >= 1) p.ngayTron += 1; else if (v > 0) p.ngayNua += 1;
        if (v !== 1) p.chiTiet.push(`${ngay}:${v}`);
      });
    }
  });
  const rows = order.map((k, i) => {
    const p = people[k];
    return { stt: i + 1, hoten: p.hoten, boPhan: p.boPhan, ghiChu: p.ghiChu, congNgay: Math.round(p.congNgay * 100) / 100, ngayTron: p.ngayTron, ngayNua: p.ngayNua, tienAnTrua: p.ngayTron * ANTRUA_DON_GIA, chiTiet: p.chiTiet.join(", ") };
  });
  return { thang, rows };
}
